import { BASE_URL } from '../api/config';
import { useUserContext } from '../context/UserContext';
import { useCallback } from 'react';

export const apiRequest = async (endpoint: string, options: RequestInit = {}) => {
  try {
    console.log(`Making request to: ${BASE_URL}${endpoint}`);
    console.log('Request headers:', options.headers);
    
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        ...options.headers,
      },
    });

    console.log('Response status:', response.status);
    console.log('Response ok:', response.ok);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error('Error response data:', errorData);
      throw new Error(errorData.message || `HTTP Error: ${response.status}`);
    }

    // Handle 304 Not Modified responses
    if (response.status === 304) {
      console.log('304 Not Modified response received');
      return []; // Return empty array for 304 responses
    }

    return await response.json();
  } catch (error) {
    console.error('Error en la petición:', error);
    if (error instanceof TypeError && error.message.includes('fetch')) {
      throw new Error('Error de conexión: No se puede conectar al servidor. Verifica que el backend esté corriendo en http://localhost:8081');
    }
    throw error;
  }
};

export const useApi = () => {
  const { user } = useUserContext();

  const get = useCallback(async (endpoint: string) => {
    return apiRequest(endpoint, {
      headers: {
        'x-auth-token': user?.token || '',
      },
    });
  }, [user?.token]);

  const post = useCallback(async (endpoint: string, data: any) => {
    return apiRequest(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'x-auth-token': user?.token || '',
      },
    });
  }, [user?.token]);

  const put = useCallback(async (endpoint: string, data: any) => {
    return apiRequest(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: {
        'x-auth-token': user?.token || '',
      },
    });
  }, [user?.token]);

  const del = useCallback(async (endpoint: string) => {
    return apiRequest(endpoint, {
      method: 'DELETE',
      headers: {
        'x-auth-token': user?.token || '',
      },
    });
  }, [user?.token]);

  return { get, post, put, delete: del };
};
